import axios from "axios";
import React, { useEffect } from "react";

import VoteBox from "../Assets/images/firest-icon.png";

import { expirationSeconds, url } from "../config";
import { useNavigate } from "react-router-dom";
export const Home = () => {
  const [expired, setExpired] = React.useState([]);
  const [notExpired, setNotExpired] = React.useState([]);
  const [currentTab, setCurrentTab] = React.useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${url}/getProposals`).then((res) => {
      console.log(res.data);
      setExpired(res.data.expired);
      setNotExpired(res.data.notExpired);
    });
  }, []);

  return (
    <div className="container">
      <div className="row center">
        <div className="col-12 col-md-12 ptb_50 alignCenter">
          <div className="heroTextBox">
            <h1 className="Title">
              Foundation <span> DAO</span>
            </h1>
            <p className="sub_p">
              Decentralized Voting for the people by the founders. We believe in
              the community, now you can burn to
              <br /> vote and propose changes to our vision forward. All will
              adhere to the proposals outcomes.
            </p>
          </div>
        </div>
        <div className="col-12 col-md-12 alignCenter">
          <div className="voteBoxImg">
            <img src={VoteBox} className="dark" alt="VoteBox" />
          </div>
        </div>
      </div>

      <div className="row ptb_100">
        <div className="col-12">
          <div className="tabSec3">
            <ul className="nav nav-pills navPills">
              <li className="nav-item">
                <button
                  onClick={() => navigate("/new")}
                  type="button"
                  className="nav-link active"
                >
                  Create proposal
                </button>
              </li>
            </ul>
            <h3>Active VoteBox</h3>
            <div class="toggle-radio" onClick={
              currentTab === 0 ? () => setCurrentTab(1) : () => setCurrentTab(0)
              
            }>
              <input type="radio" name="rdo" id="yes" checked={currentTab === 0}/>
              <input type="radio" name="rdo" id="no" checked={currentTab === 1}/>
              <div class="switch">
                <label for="yes">Active</label>
                <label for="no">Closed</label>
                <span></span>
              </div>
            </div>
          </div>
          

          {/* <ul className="nav nav-pills navPills mb-4">
            <li className="nav-item">
              <a
                className="nav-link active"
                data-toggle="pill"
                href="#ActiveVotes"
              >
                Active
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="pill" href="#ClosedVotes">
                Closed
              </a>
            </li>
          </ul> */}

        </div>
        <div className="col-12">
          <div className="tab-content newTb">
            <div className={`tab-pane ${currentTab !== 1 ? "active" : "fade"}`} id="ActiveVotes">
              <div className="row">
                {notExpired.map((item, index) => {
                  return (

                    <>
                      <div
                        className="col-12 col-md-4"
                        onClick={() => navigate("/proposals/" + item.id)}
                      >
                        <div className="plan_card">
                          <div className="plan_cardHead">
                            <h4>VOTING OPEN</h4>
                            <div className="plan_Price">{parseInt(item.yes_votes) + parseInt(item.no_votes)} <span className="plan_Time">VOTES</span></div>
                          </div>
                          <div className="plan_cardBody">
                            <div className="progress">
                              <div
                                  className="progress-bar"
                                  style={{ width: item.percent + "%" }}
                                  >
                                    {item.percent + "%"}
                              </div>
                            </div>
                            <div className="progressBottom">
                                <div className="">0%</div>
                                <div className="">100%</div>
                            </div>
                            <div class="voteInfo">
                              <label class="label_">HIP</label>
                              {/*<label class="label_ label_active">Temp Check</label> */}
                              <h6>{item.title}</h6>
                              <p>{item.description}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    
                   
                    {/* <div
                      className="col-12 col-md-4"
                      onClick={() => navigate("/proposals/" + item.id)}
                    >
                      <div className="voteCard">
                        <div className="votText-n">
                          <div className="top-box">
                            <div className="Count__">
                              {parseInt(item.yes_votes) + parseInt(item.no_votes)}
                            </div>
                            <div className="Count__Text">Votes</div>
                          </div>
                          <div className="Count__Text Votingopen">
                            Voting Open
                          </div>
                        </div>
                        <div className="progress">
                          <div
                            className="progress-bar"
                            style={{ width: item.percent + "%" }}
                          >
                            {item.percent + "%"}
                          </div>
                        </div>
                        <div className="progressBottom">
                          <div className="">0%</div>
                          <div className="">100%</div>
                        </div>

                        <div className="voteInfo">
                          <label className="label_">FND</label>
                          <label className="label_ label_active">Temp Check</label>
                          <h6>{item.title}</h6>
                          <p>{item.description}</p>
                        </div>
                      </div>
                    </div> */}
                    </>
                  );
                })}
              </div>
            </div>
            <div className={`tab-pane ${currentTab === 1 ? "active" : "fade"}`} id="ClosedVotes">
              <div className="row">
                {expired.length == 0 && (
                  <div className="col-12 col-md-12">
                    <p>No expired proposals yet.</p>
                  </div>
                )}
                {expired.map((item, index) => {
                  return (
                    <>
                      <div
                        className="col-12 col-md-4 closedSec"
                        onClick={() => navigate("/proposals/" + item.id)}
                      >
                        <div className="plan_card">
                          <div className="plan_cardHead">
                            <h4>VOTING OPEN</h4>
                            <div className="plan_Price">({parseInt(item.yes_votes) > parseInt(item.no_votes) ? "Passed" : "Rejected"})<span className="plan_Time">VOTES</span></div>
                          </div>
                          <div className="plan_cardBody">
                            <div class="voteInfo">
                              <h6>{item.title}</h6>
                              <p>{item.description}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row pb_100">
        <div className="col-12 howdoesWork">
          {/* <ul className="nav nav-pills navPills mb-4">
            <li className="nav-item">
              <button
                onClick={() => navigate("/new")}
                type="button"
                className="nav-link active"
              >
                Create proposal
              </button>
            </li>
          </ul> */}
        </div>
        <div className="col-12 howdoesWork">
          <h3>Our Process</h3>
          <p>
            Anything and everything can be proposed. You can vote as many times
            as you like. The founders will ensure the DAO outcomes are followed
            through. We are merely a pawn in the vision the community will vote
            on to help pave our roadmap forward. Our goal is decentralization
            and with this DAO and burn to vote and propose feature you will get
            us there. CONNECT YOUR WALLET AND START PROPOSING AND VOTING AS
            OFTEN AS YOU LIKE.
          </p>
        </div>
      </div>
    </div>
  );
};
export default Home;
